import { InputAdornment, Stack } from "@mui/material";
import React, { useRef } from "react";
import { InputControl, ScrollButton, SearchChip, SelectChip } from "../../../shared";
import CloseIcon from "@mui/icons-material/Close";
import TemplateCustomTable from "./TemplateCustomTable";

export const RegenerateTemplate = ({
  categorylistQuery,
  templates,
  onChangeFilter,
  onSearchChange,
  searchHandler,
  handleCustomFieldChange,
  recipelistQuery,
}) => {
  const [search, setSearch] = React.useState("");

  const categoryRef = useRef(null);

  const handleHorizontalScroll = (element, speed, distance, step) => {
    let scrollAmount = 0;
    const slideTimer = setInterval(() => {
      element.scrollLeft += step;
      scrollAmount += Math.abs(step);
      if (scrollAmount >= distance) {
        clearInterval(slideTimer);
      }
    }, speed);
  };

  const onChange = (event) => {
    const { value } = event.target;
    setSearch(value);
    onSearchChange(value, templates.groupedDatas);
  };

  const clearSearch = () => {
    setSearch("");
    searchHandler("");
  };

  React.useEffect(() => {
    return () => {
      clearSearch();
    };
  }, []);

  return (
    <>
      <Stack direction="row" gap="10px" alignItems="center" ml={1}>
        <InputControl
          sx={{ width: "200px", borderRadius: "10px" }}
          type="table-search"
          placeholder="Search"
          // onChange={(e) =>
          //   onSearchChange(e.target.value, templates.groupedDatas)
          // }
          onChange={onChange}
          value={search}
          // value={templates.filter.search}
          endAdornment={
            templates.filter.search && (
              <InputAdornment sx={{ cursor: "pointer" }} position="end">
                <CloseIcon size="large" onClick={clearSearch} />
              </InputAdornment>
            )
          }
        />
        <ScrollButton
          categoryRef={categoryRef}
          onClick={handleHorizontalScroll}
          step={-10}
        >
          <img alt="details" src="/icons/Intersect.png" />
        </ScrollButton>
        {search && (
          <SearchChip
            count={templates.templateResultRows.length}
            value={search}
          />
        )}
        <Stack
          direction="row"
          width="100%"
          overflow="auto"
          gap={1}
          className="scroll-hide"
          ref={categoryRef}
        >
          {categorylistQuery?.data?.map((v, i) => (
            <SelectChip
              key={i}
              value={v}
              isSelected={
                search
                  ? false
                  : templates.filter.category
                    ? templates.filter.category === v.id
                    : i === 0
              }
              sx={search && { cursor: "not-allowed" }}
              onClick={() =>
                !search && onChangeFilter(v, templates.groupedDatas)
              }
            />
          ))}
        </Stack>
        <ScrollButton
          categoryRef={categoryRef}
          onClick={handleHorizontalScroll}
          step={10}
        >
          <img alt="details" src="/icons/Intersect1.png" />
        </ScrollButton>
      </Stack>
      <TemplateCustomTable
        rows={templates.templateResultRows}
        handleCustomFieldChange={handleCustomFieldChange}
        recipelistQuery={recipelistQuery}
        data={templates}
      />
    </>
  );
};
